// extracted by mini-css-extract-plugin
export default {"tabs":"Z2bIN","title":"MXrhv","titleIcon":"owRbc"};